export type FlexProps = 'column' | 'row' | 'row-reverse' | 'column-reverse';

type Breakpoints = 'base' | 'sm' | 'md' | 'lg' | 'xl';

export type FlexObject = Partial<Record<Breakpoints, FlexProps>>;

export type AlignProps = 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';

export type AlignObject = Partial<Record<Breakpoints, AlignProps>>

export type JustifyProps = 'center' | 'flex-end' | 'flex-start' | 'space-around' | 'space-between' | 'space-evenly';

export type JustifyObject = Partial<Record<Breakpoints, JustifyProps>>

const CHAKRA_DIRECTION_PROP_TO_TAILWIND_CLASS: Record<FlexProps, string> = {
  column: 'flex-col',
  'column-reverse': 'flex-column-reverse',
  row: 'flex-row',
  'row-reverse': 'flex-row-reverse',
};

const CHAKRA_ALIGN_PROP_TO_TAILWIND_CLASS: Record<AlignProps, string> = {
  baseline: 'items-baseline',
  center: 'items-center',
  'flex-end': 'items-end',
  'flex-start': 'items-start',
  stretch: 'items-stretch',

}

const CHAKRA_JUSTIFY_PROP_TO_TAILWIND_CLASS: Record<JustifyProps, string> = {
  center: 'justify-center',
  'flex-end': 'justify-end',
  'flex-start': 'justify-start',
  'space-around': 'justify-around',
  'space-between': 'justify-between',
  'space-evenly': 'justify-evenly'
}

export const convertChackraResponsiveValueToTailwindClass = (
  chakraDirectionProp: FlexObject | string | undefined
): string | undefined => {
  if (!chakraDirectionProp) return undefined;
  if (typeof chakraDirectionProp === 'string') {
    return chakraDirectionProp === 'column' ? 'flex-col' : 'flex-row';
  }
  return Object.keys(chakraDirectionProp)
    .reduce((classes, breakpoint: Breakpoints) => {
      const chakraProp = chakraDirectionProp[breakpoint];
      const responsivePrefix = breakpoint === 'base' ? '' : `${breakpoint}:`;
      return (classes += `${responsivePrefix}${CHAKRA_DIRECTION_PROP_TO_TAILWIND_CLASS[chakraProp]} `);
    }, '')
    .trim();
};

export const convertChackraAlignToTailwindClass = (chackraAlignProp: AlignObject | AlignProps): string => {
  if (!chackraAlignProp) return undefined;
  if (typeof chackraAlignProp === 'string') {
    return CHAKRA_ALIGN_PROP_TO_TAILWIND_CLASS[chackraAlignProp]
  }
  return Object.keys(chackraAlignProp)
    .reduce((classes, breakpoint: Breakpoints) => {
      const chackraProp = chackraAlignProp[breakpoint]
      const responsivePrefix = breakpoint === 'base' ? '' : `${breakpoint}:`;
      return (classes += `${responsivePrefix}${CHAKRA_ALIGN_PROP_TO_TAILWIND_CLASS[chackraProp]} `)
    }, '')
    .trim();
}

export const convertChackraJustifyToTailwindClass = (chackraJustifyProp: JustifyObject | JustifyProps): string => {
  if (!chackraJustifyProp) return undefined;
  if (typeof chackraJustifyProp === 'string') {
    return CHAKRA_JUSTIFY_PROP_TO_TAILWIND_CLASS[chackraJustifyProp]
  }

  return Object.keys(chackraJustifyProp)
    .reduce((classes, breakpoint: Breakpoints) => {
      const chackraProp = chackraJustifyProp[breakpoint]
      const responsivePrefix = breakpoint === 'base' ? '' : `${breakpoint}:`;
      return (classes += `${responsivePrefix}${CHAKRA_JUSTIFY_PROP_TO_TAILWIND_CLASS[chackraProp]} `)
    }, '')
    .trim();
}